export default __webpack_public_path__ + "static/media/img_about02-m.7c9acb59.png";